module.exports = __webpack_public_path__ + "img/logo.6afb2e98.png";